import template from './phoneField.html';
import controller from './phoneField.controller';

let component = {
  restrict: 'E',
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    fieldResponse: '<',
    onUpdate: '&',
  }
};

export default component;
